module.exports = __webpack_public_path__ + "img/015-telegram.fa1da4e9.svg";